import styled, { keyframes } from 'styled-components';
import bg from '../../../assets/Background.svg';
import trainingBg from '../../../assets/Image.png';
import trainingBgbig from '../../../assets/Imagebig.png';
import { Image } from '@chakra-ui/react';

// const colorAnimation = keyframes`
//  0% { background-color: #fff; color:#090a0a;}
//  25% { background-color: #1b3b5f; color:#fff;}
//  50% { background-color: #1b3b5f; color:#fff;}
//  100% {background-color: #fff ; color:#090a0a;}
// `;
const scaleAnimation = keyframes`
  0% { transform: scale(1); }
  50% { transform: scale(1.2); }
  100% { transform: scale(1); }
`;

export const AnimatedImage = styled(Image)`
    animation: ${scaleAnimation} 3s ease-in-out infinite;
`;

export const RoundImage = styled.div`
    border-radius: 50%;
    width: 297px;
    height: 297px;
    overflow: hidden;
    background: #7fdbd440;
    margin-inline: auto;
    padding-top: 40px;
`;

export const SplashContainer = styled.section`
    position: fixed;
    padding-bottom: 1rem;
    height: 100vh;
    width: 100%;
    overflow: hidden;
    background-color: #fff;
    color: #090a0a;

    h1 {
        font-style: normal;
        font-weight: 700;
        font-size: 32px;
        line-height: 36px;
        text-align: center;
        width: 237px;
        margin-bottom: 58px;
    }

    a {
        width: 90%;
        button {
            height: 48px;
            color: #090a0a;
            bottom: 38px;
            background: #fff;
            width: 100%;
            border-radius: 48px;
            font-weight: 500;
            font-size: 16px;
            line-height: 16px;
            margin-top: 70px;
            margin-bottom: 15px;
        }
    }
`;

export const GetStartedContainer = styled.section`
    /* position: fixed; */
    height: 100vh;
    width: 100%;
    padding-block: 2rem;
    overflow-x: hidden;
    overflow-y: auto;
    background-color: #f2f4f5;
    .control-dots {
        margin-bottom: 0 !important;
    }
    .carousel .thumbs-wrapper {
        margin: 15px;
    }
    .dot {
        background-color: #6b4eff !important;
        opacity: 1;
    }

    .carousl {
        /* height: max-content; */
        img {
            object-fit: contain;
            width: 100%;
            height: 100%;
        }

        h3 {
            width: 90%;
            font-style: normal;
            font-weight: 700;
            font-size: 24px;
            line-height: 32px;
            margin: auto;
            text-align: center;
            color: #1b3b5f;
            margin-top: 25px;
            margin-bottom: 50px;
        }
    }
    p {
        color: #202325;
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
        a {
            color: #1b3b5f;
            font-weight: 700;
        }
    }
    a {
        width: 50%;
        button {
            width: 100%;
            height: 48px;
            background: #1b3b5f;
            border-radius: 48px;
            color: #ffffff;
        }
    }
`;

export const VerifyContainer = styled.section`
    position: fixed;
    width: 100%;
    padding-bottom: 1rem;
    padding-top: 1rem;
    overflow: auto;
    height: 100vh;
    button {
        border-radius: 48px;
        margin-top: 22%;
        background: #1b3b5f;
        font-weight: 500;
        font-size: 16px;
        line-height: 16px;
        color: #fff;
        :disabled {
            background: #e3e5e5;
            color: #979c9e;
        }
    }
`;
export const DealsContainer = styled.section`
    width: 100%;
    padding-top: 2rem;
    padding-bottom: 1rem;
    position: fixed;
    height: 100vh;
    background-color: #f2f4f5;
    button {
        color: white;
        background: #1b3b5f;
        height: 48px;
        border-radius: 48px;
        width: 90%;
    }
`;
export const CategoryContainer = styled.section`
    /* position: fixed; */
    width: 100%;
    padding-bottom: 1rem;
    padding-top: 1rem;
    button {
        border: 1px solid #1b3b5f;
        background-color: #fff;
        text-align: left;
        color: #090a0a;
        :disabled {
            height: 40px;
            font-weight: 400;
            font-size: 16px;
            line-height: 16px;
            opacity: 1;
        }
        :focus {
            background: #dcdcff;
        }
    }
    .not-selected {
        height: 40px;
        font-weight: 400;
        font-size: 16px;
        line-height: 16px;
    }

    .selected {
        border-radius: 8px;
        height: 40px;
        font-weight: 400;
        font-size: 16px;
        line-height: 16px;
    }
    .btn {
        color: white;
        background: #1b3b5f;
        height: 48px;
        border-radius: 48px;
        width: 100%;
        :disabled {
            opacity: 0.2;
        }
    }
`;
export const PreOffersContainer = styled.section`
    width: 100%;
    /* margin-bottom: 1rem; */
    display: flex;
    /* position: fixed; */
    @media screen and (max-width: 500px) {
        padding-top: 2rem;
    }
`;

export const ActionContainer = styled.section`
    width: 100%;
    padding-top: 1rem;
    padding-bottom: 1rem;
    background-color: #f2f4f5;
    background-repeat: no-repeat;
    background-position-y: bottom;
    background-position-x: right;
    background-image: url(${bg});
    background-size: cover;
    height: 100%;
    /* button {
        color: white;
        background: #1b3b5f;
        height: 48px;
        border-radius: 48px;
        width: 90%;
    } */
    @media screen and (max-width: 500px) {
        position: fixed;
        background-size: contain;
        height: 100vh;
    }
`;

export const TrainingContainer = styled.section`
    padding-bottom: 1rem;
    padding-top: 2rem;
    height: 100vh;

    background-repeat: no-repeat;
    background-image: none;
    background-position-y: bottom;
    background-position-x: right;
    background-size: cover;
    width: 80%;
    margin: auto;
    @media screen and (max-width: 500px) {
        position: fixed;
        background-size: cover;
        height: 100vh;
        width: 100%;
        background-image: url(${trainingBg});
    }
    .training-img {
        background-image: url(${trainingBgbig});
        background-size: contain;
        background-repeat: no-repeat;
    }
`;

export const CompleteTrainingContainer = styled.section`
    width: 100%;
    padding-bottom: 1rem;
    padding-top: 2rem;
    background-color: #f2f4f5;
    height: 100%;
    button {
        color: white;
        background: #1b3b5f;
        height: 48px;
        border-radius: 48px;
        width: 90%;
    }
    @media screen and (max-width: 500px) {
        position: fixed;
        height: 100vh;
        width: 100%;
    }
`;

export const ProfileConatiner = styled.section`
    width: 75%;
    padding-bottom: 4rem;
    margin-right: auto;
    margin-left: 4rem;
    select {
        padding-inline-end: 0;
    }
    .noTop {
        margin-top: 0;
    }
    @media screen and (max-width: 500px) {
        width: 100%;
        margin-right: auto;
        margin-left: auto;
        padding-top: 1.5rem;
    }
    /* input[type='date']::-webkit-calendar-picker-indicator {
        display: none;
        -webkit-appearance: none;
    } */
`;
